import Instance from "../../../../Axios";

// New Actions for the app

const GetEstadosPropostasParceiro =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/estadosPropostasParceiro`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_ESTADOS_PROPOSTAS_PARCEIRO",
          payload: data.yData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetEstadosPropostasParceiro;
